<template>
  <Container :style="{ padding: currentPath === homePath ? '4px 0' : '0' }">
    <!-- sticky top-0 z-10 -->
    <div
      v-if="currentPath === homePath && visibleRouteList.length > 0"
      class="custom-sub-tabs-container"
      :style="{ padding: currentPath === homePath ? '4px 24px' : '0' }"
    >
      <el-tabs v-model="activeIndex" @tab-change="handleRouteChange">
        <el-tab-pane
          v-for="(category, index) in visibleRouteList"
          :key="index"
          :label="category.meta?.title"
          :name="index"
          lazy
        />
      </el-tabs>
    </div>
    <div v-else :style="{ padding }">
      <!-- sticky top-0 z-10 -->
      <NavBack :isBack="true" :showTitle="false" class="b-rd-t-6px" />
    </div>
    <div class="flex-grow-1 overflow-auto">
      <router-view />
    </div>
  </Container>
</template>

<script lang="ts" setup>
import type { RouteRecordRaw } from "vue-router"
import { computed, toRefs } from "vue"
import { useRouter } from "vue-router"
import { getActiveRoute, getVisibleLevelTwoRoutes } from "@/hooks/useRouter"

const props = defineProps<{
  routeList: RouteRecordRaw[]
}>()

const router = useRouter()
const { routeList } = toRefs(props)
const visibleRouteList = computed(() => getVisibleLevelTwoRoutes(routeList.value))
const currentPath = computed(() => {
  return router.currentRoute.value.path.split("/").pop()
})
// JZTODO 判断当前界面是否需要展示tab选项卡，优化判断条件
const homePath = 'index'
const padding = computed(() => {
  return currentPath.value === homePath ? '4px 0' : '0'
})

const { activeIndex, handleRouteChange } = getActiveRoute(router, visibleRouteList.value)
</script>
